export default __webpack_public_path__ + "static/media/article_no_image.c1046b67.svg";